var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDataLoading)?_c('div',{staticClass:"d-flex justify-content-center align-items-center h-100"},[_c('Preloader')],1):_c('EditProfile',{attrs:{"userId":_vm.userId,"isUserProfile":_vm.isUserProfile,"userData":_vm.tableData,"breadcrumbs":[{
    text: 'Home',
    to: { name: 'home' }
  }, { text: _vm.name, click: () => _vm.onClose() }]},on:{"close":_vm.onClose,"profileUpdate":_vm.onProfileUpdate,"avatarUpdate":_vm.onAvatarUpdate,"getName":_vm.getName}})
}
var staticRenderFns = []

export { render, staticRenderFns }